(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-sz-deadline]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-sz-deadline'));
      var left = end - now;
      if (isNaN(end)) return;
      if (left <= 0) {
        var box = el.closest('[data-sz-bf]');
        if (box) box.hidden = true;
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      var parts = { d: d, h: pad(h), m: pad(m), s: pad(sec) };
      var cells = el.querySelectorAll('[data-u]');
      if (cells.length) {
        cells.forEach(function (c) { c.textContent = parts[c.getAttribute('data-u')]; });
      } else {
        el.textContent = 'Noch ' + d + ' T. ' + pad(h) + ':' + pad(m) + ':' + pad(sec);
      }
    });
  }
  tick();
  setInterval(tick, 1000);

  var rv = document.querySelectorAll('.sz-rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('is-in'); });
  }

  document.querySelectorAll('[data-sz-banners]').forEach(function (wrap) {
    var track = wrap.querySelector('.sz-banners__track');
    var prev = wrap.querySelector('[data-prev]');
    var next = wrap.querySelector('[data-next]');
    var dots = wrap.querySelectorAll('.sz-banners__dots button');
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function sync() {
      var i = idx();
      var max = track.children.length - 1;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= max;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();

document.addEventListener('click', function (e) {
  var a = e.target.closest('.kz-cta');
  if (!a || (a.getAttribute('href') || '#') !== '#') return;
  var btn = document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
  if (!btn) return;
  e.preventDefault();
  btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (!btn.disabled) btn.click();
});
